import { effects } from 'redux-saga'
import { vsprintf } from 'sprintf-js'
import { parse } from 'query-string'

import { clear, login } from '../../modules/authentication'

export default function* parseSaga(authUrl, getHref, setHref, action) {
  const hash = yield effects.call(parse, action.payload.location.hash)

  if (!hash.access_token) {
    yield effects.put.resolve(clear())

    const href = yield effects.call(getHref)
    const location = vsprintf(authUrl, [encodeURIComponent(href)])
    yield effects.call(setHref, location)

    return
  }

  yield effects.put.resolve(login(hash, action.payload.location.query.returnTo))
}



// WEBPACK FOOTER //
// ./deps/internal-components/src/redux/sagas/authentication/parse.js